/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Footnote_VisitInputs */

const en_admin_funnel_footnote_visit = /** @type {(inputs: Admin_Funnel_Footnote_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visitors = browsers that opened the generator page (/ or /ai-livestream, event hl_home_view, sent from the browser; bot user agents dropped).`)
};

/**
* | output |
* | --- |
* | "Visitors = browsers that opened the generator page (/ or /ai-livestream, event hl_home_view, sent from the browser; bot user agents dropped)." |
*
* @param {Admin_Funnel_Footnote_VisitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_footnote_visit = /** @type {((inputs?: Admin_Funnel_Footnote_VisitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Footnote_VisitInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_footnote_visit(inputs)
});
export { admin_funnel_footnote_visit as "admin.funnel.footnote.visit" }